import { TimelineLite, TweenMax } from 'gsap';
import 'ScrollToPlugin';
import ScrollMagic from 'scrollmagic';
// import 'scrollmagic/scrollmagic/minified/plugins/debug.addIndicators.min';
import 'animation.gsap';
import detectMobile from '@/scripts/utils/detect-mobile';

document.addEventListener('DOMContentLoaded', () => {
  const controller = new ScrollMagic.Controller();

  const $elements = $('.content .editable')
    .add('.content .buttons')
    .add('.content .social')
    .add('.content .input-block');
  $elements.each((i, el) => {
    const tween = TweenMax.staggerFromTo(el.children, 0.5, {
      autoAlpha: 0,
      y: 30,
    }, {
      autoAlpha: 1,
      y: 0,
    }, 0.2);
    new ScrollMagic.Scene({
      reverse: false,
      triggerElement: el,
      triggerHook: 0.9,
    }).setTween(tween)
      .addTo(controller);
  });
  $('[data-animation="devider"]').each((i, el) => {
    const tl = new TimelineLite();
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 0.9,
    }).on('start', () => {
      const $line1 = $(el).find('[data-type="devider-line"]');
      const $line2 = $(el).find('[data-type="devider-line-2"]');
      const $line3 = $(el).find('[data-type="devider-line-3"]');

      tl
        .fromTo($line2, 1, {scaleY: 5, y: -80}, {scaleY: 1, y: 0})
        .fromTo($line1, 1, {scaleY: 0}, {scaleY: 1}, 0)
        .fromTo($line3, 1, {scaleX: 0}, {scaleX: 1});
    }).addTo(controller);
  });
  $('[data-animation="revealer-stripes"]').each((i, el) => {
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 0.9,
    }).on('start', () => {
      const $stripes = $(el).find('.stripe');
      if ($stripes.length) {
        TweenMax.staggerFromTo($stripes, 2, {scaleY: 1}, {
          scaleY: 0,
          transformOrigin: 'bottom center',
        }, 0.2);
      }
    }).addTo(controller);
  });
  $('[data-animation="section"]').each((i, el) => {
    const tween = TweenMax.fromTo(el, 1, {autoAlpha: 0, y: 60}, {
      autoAlpha: 1,
      y: 0,
      ease: Linear.easeNone,
    });
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: el,
      triggerHook: 0.9,
    }).setTween(tween)
      .addTo(controller);
  });
  $('[data-animation="list"]').each((i, el) => {
    $(el.children).each((k, elem) => {
      const tween = TweenMax.fromTo(elem, 1.5, {autoAlpha: 0, y: 60}, {
        autoAlpha: 1,
        y: 0,
        ease: Linear.easeNone,
      }, 0.2);
      new ScrollMagic.Scene({
        duration: 0,
        reverse: false,
        triggerElement: elem,
        triggerHook: 0.9,
      }).setTween(tween)
        .addTo(controller);
    });
  });
  (() => {
    const $coverImg = $('.cover_page img')[0];
    new ScrollMagic.Scene({
      duration: 0,
      reverse: false,
      triggerElement: $coverImg,
      triggerHook: 'onEnter',
    }).on('start', () => {
      TweenMax.fromTo($($coverImg), 10, {scale: 1.3, x: 35, z: 0}, {scale: 1.3, x: -35, z: 0});
    }).addTo(controller);
  })();
  // parallax
  if (!detectMobile()) {
    $('[data-animation="parallax"]').each((i, el) => {
      const multiplier = 100;
      let top;
      new ScrollMagic.Scene({
        duration: '100%',
        triggerElement: el,
        offset: -200,
      }).on('progress', (event) => {
        top = (event.progress * multiplier) - 50;
        TweenMax.to(el, 0.7, { y: top });
      }).addTo(controller);
    });
    $('[data-animation="back-border"]').each((i, el) => {
      const tl = new TimelineLite();
      new ScrollMagic.Scene({
        duration: 0,
        reverse: false,
        triggerElement: el,
        triggerHook: 'onEnter',
      }).on('start', () => {
        const $lines = $(el).find('.parallax-line');
        if ($lines.length) {
          $lines.each((k, line) => {
            tl.fromTo(line, 0.035, {scale: 0}, {scale: 1});
          });
        }
      }).addTo(controller);
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/scrollmagic.js